enum PreAnestesicoEnum {
  'Null' = 'null',
  'Pendente' = 'pendente',
  'Apto' = 'apto',
  'AptoComAtencao' = 'aptoComAtencao',
  'NaoApto' = 'naoApto',
}

export default PreAnestesicoEnum
